import { render, staticRenderFns } from "./StackedBarChartViz.vue?vue&type=template&id=35b40c4c&scoped=true&"
import script from "./StackedBarChartViz.vue?vue&type=script&lang=js&"
export * from "./StackedBarChartViz.vue?vue&type=script&lang=js&"
import style0 from "./StackedBarChartViz.vue?vue&type=style&index=0&id=35b40c4c&scoped=true&lang=scss&"
import style1 from "./StackedBarChartViz.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b40c4c",
  null
  
)

export default component.exports